/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Icon } from 'semantic-ui-react'
import { THEME_COLORS } from '../../Shared/theme'

const ValueVariation = ({ value, referenceValue, formatter }) => {
    if (referenceValue === undefined || referenceValue === null || isNaN(referenceValue)) {
        return null
    }

    const diff = value - referenceValue
    const isPositive = diff > 0

    if (diff === 0) return null

    const color = isPositive ? THEME_COLORS.GREEN : THEME_COLORS.RED
    const arrowIcon = isPositive ? 'arrow up' : 'arrow down'
    const formattedDiff = formatter ? formatter(Math.abs(diff)) : Math.abs(diff)
    const label = isPositive ? `+${formattedDiff}` : `-${formattedDiff}`

    return (
        <span
            css={css`
                display: inline-flex;
                align-items: center;
                position: relative;
                top: -1em;
                margin-left: 0.2rem;
                font-size: 0.4em;
                color: ${color};
                line-height: 1;
            `}
        >
            <Icon
              name={arrowIcon}
              css={css`
                  margin: 0 .2em 0 0 !important;
              `}
            />
            <span css={css`line-height: 1;`}>{label}</span>
        </span>
    )
}

export { ValueVariation }
